<form (ngSubmit)="onSubmit()" [formGroup]="formClient">
  <p-dialog header="Añadir Cliente" [modal]="true" [maximizable]="true" [(visible)]="visible"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '50vw' }" (onHide)="closeDialog()">
    <div class="flex flex-column gap-4 mt-3">
      <!-- Sección Información Personal -->
      <div>
        <div class="text-900 font-bold text-xl mb-3 flex align-items-center gap-2">
          <i class="pi pi-user text-primary"></i> Información Personal
        </div>
        <div class="formgrid grid">
          <div class="col-12 md:col-6">
            <app-input label="Nombre*" [formControl]="formUtilities.getControl(formClient, 'name')" name="name"
              type="text-required" [customErrorMessages]="{ required: 'Este campo es requerido' }"></app-input>
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Apellidos" formControlName="surname" name="surname"></app-input>
          </div>
        </div>
      </div>

      <p-divider></p-divider>

      <!-- Sección Contacto -->
      <div>
        <div class="text-900 font-bold text-xl mb-3 flex align-items-center gap-2">
          <i class="pi pi-phone text-primary"></i> Contacto
        </div>
        <div class="formgrid grid">
          <div class="col-12 md:col-6">
            <app-input label="Nombre contacto" formControlName="name_contact" name="name_contact"></app-input>
          </div>
          <div class="col-12 md:col-6">
            <app-input label="Email" formControlName="email" name="email" type="email"
              [customErrorMessages]="{ email: 'Formato de email inválido' }"></app-input>
          </div>
          <div class="col-12 md:col-3">
            <app-input label="Teléfono" formControlName="phone" name="phone" type="number"></app-input>
          </div>
          <div class="col-12 md:col-3">
            <app-input label="Teléfono (opc.)" formControlName="phone_optional" name="phone_optional" type="number"></app-input>
          </div>
        </div>
      </div>

      <p-divider></p-divider>

      <!-- Sección Ubicación -->
      <div>
        <div class="text-900 font-bold text-xl mb-3 flex align-items-center gap-2">
          <i class="pi pi-map-marker text-primary"></i> Ubicación
        </div>
        <div class="formgrid grid">
          <div class="col-12">
            <app-input label="Dirección" formControlName="address" name="address"></app-input>
          </div>
          <div class="col-12 md:col-4">
            <app-input label="Población" formControlName="city" name="city"></app-input>
          </div>
          <div class="col-12 md:col-4">
            <app-input label="Provincia" formControlName="province" name="province"></app-input>
          </div>
          <div class="col-12 md:col-4">
            <app-input label="Código Postal" formControlName="postal_code" name="postal_code" type="number-length"
              [minLength]="5" [customErrorMessages]="{ minlength: 'Mínimo 5 caracteres' }"></app-input>
          </div>
        </div>
      </div>

      <p-divider></p-divider>

      <!-- Sección Fiscal y Otros -->
      <div>
        <div class="text-900 font-bold text-xl mb-3 flex align-items-center gap-2">
          <i class="pi pi-file text-primary"></i> Fiscal y Otros
        </div>
        <div class="formgrid grid">
          <div class="col-12 md:col-6">
            <app-input label="NIF/CIF" formControlName="nif_cif" name="nif_cif"></app-input>
          </div>
          <div class="col-12">
            <div class="field">
              <label for="observation" class="font-semibold block mb-2">Observaciones</label>
              <span class="w-full">
                <textarea id="observation" class="w-full" pInputTextarea [rows]="3" autocomplete="off"
                  formControlName="observation" placeholder="Notas adicionales..."></textarea>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <p-button label="Cancelar" severity="secondary" icon="pi pi-times" (onClick)="closeDialog()"
          [outlined]="true"></p-button>
        <p-button label="Guardar Cliente" type="submit" icon="pi pi-check" [disabled]="formClient.invalid"></p-button>
      </div>
    </ng-template>
  </p-dialog>
</form>